import { SagaIterator } from 'redux-saga'
import * as effects from 'redux-saga/effects'
import * as api from './api'
import * as actions from './actions'
import * as apiProfile from '../SignInPage/api'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'
import { InviteFormType } from './types'

function* fetchTeachers(): SagaIterator {
  try {
    const teachers = yield effects.call(api.fetchTeachers)
    yield effects.put(actions.fetchTeachersSuccess(teachers.teachers))
  } catch (error) {
    console.warn('Cannot fetch teachers', error)
    yield effects.put(actions.fetchTeachersFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* sendInviteTeacher(payload: { data: InviteFormType }): SagaIterator {
  try {
    yield effects.call(api.sendInviteTeacher, payload.data)
    yield effects.put(actions.sendInviteTeacherSuccess())
  } catch (error) {
    console.warn('Cannot send invite teacher', error)
    yield effects.put(
      actions.sendInviteTeacherFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* connectTeacher(payload: { short_id: string }): SagaIterator {
  try {
    const { REACT_APP_URL, REACT_APP_URI_PREFIX } = process.env
    const data = yield effects.call(
      api.fetchReferralLink,
      'learner',
      `${REACT_APP_URL}${REACT_APP_URI_PREFIX}/signin`,
      '1',
      'many-to-many'
    )
    yield effects.call(
      api.connectByShortId,
      data.referral_link_object.code,
      payload.short_id
    )
    yield effects.call(apiProfile.fetchProfile)
    yield effects.put(actions.fetchTeachers())
    yield effects.put(actions.connectTeacherSuccess())
  } catch (error) {
    console.warn('Cannot connect teacher', error)
    yield effects.put(actions.connectTeacherFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchFetchTeachers(): SagaIterator {
  yield effects.takeEvery(actions.fetchTeachers.toString(), fetchTeachers)
}

function* watchSendInviteTeacher(): SagaIterator {
  yield effects.takeEvery(
    actions.sendInviteTeacher.toString(),
    sendInviteTeacher
  )
}

function* watchConnectTeacher(): SagaIterator {
  yield effects.takeEvery(actions.connectTeacher.toString(), connectTeacher)
}

export default function* watchProfileTeachers(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchTeachers),
    effects.fork(watchSendInviteTeacher),
    effects.fork(watchConnectTeacher),
  ])
}
